import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 6,
  class: "d-flex"
}
const _hoisted_2 = { class: "d-flex overflow-auto" }

import {
  ElInput,
  ElSelect,
  ElColorPicker,
  ElSwitch,
  ElInputNumber,
  ElOption,
} from "element-plus";
import { ref, watch } from "vue";
import { cloneDeep } from "lodash-es";
import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputSelector',
  props: {
    preference: {},
    keyVal: {}
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;

const emit = __emit;

const val = ref(cloneDeep(props.preference.value));

const predefinedColors = ref([
  "rgba(191, 181, 205, 1)",
  "#b5c0cd",
  "rgba(251, 193, 123, 0.64)",
  "rgba(144, 238, 144, 0.5)",
  "rgba(121, 166, 167, 0.63)",
  "rgba(146, 199, 251, 1)",
  "rgba(228, 172, 181, 1)",
  "rgba(238, 231, 191, 1)",
  "rgba(165, 249, 165, 0.5)",
  "rgba(115, 184, 186, 1)",
  "hsla(209, 100%, 56%, 0.73)",
  "rgba(190, 226, 227, 1)",
  "#c7158577",
]);

function convertToNormalText(string) {
  const result = string.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
}

function updateValue() {
  emit("update-data", props.keyVal, val.value);
}

watch(
  () => props.preference.value,
  () => {
    val.value = cloneDeep(props.preference.value);
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.preference.type === 'string')
      ? (_openBlock(), _createBlock(_unref(ElInput), {
          key: 0,
          modelValue: val.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((val).value = $event)),
          onChange: updateValue,
          class: "width-100",
          size: "small",
          placeholder: _unref(t)(_ctx.preference.label)
        }, null, 8, ["modelValue", "placeholder"]))
      : _createCommentVNode("", true),
    (_ctx.preference.type === 'enum')
      ? (_openBlock(), _createBlock(_unref(ElSelect), {
          key: 1,
          modelValue: val.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((val).value = $event)),
          onChange: updateValue,
          class: "width-100",
          size: "small",
          placeholder: _unref(t)(_ctx.preference.label)
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preference.options, (option) => {
              return (_openBlock(), _createBlock(_unref(ElOption), {
                value: option,
                label: convertToNormalText(option),
                key: option
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"]))
      : _createCommentVNode("", true),
    (_ctx.preference.type === 'color')
      ? (_openBlock(), _createBlock(_unref(ElColorPicker), {
          key: 2,
          modelValue: val.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((val).value = $event)),
          onChange: updateValue,
          predefine: predefinedColors.value,
          "show-alpha": ""
        }, null, 8, ["modelValue", "predefine"]))
      : _createCommentVNode("", true),
    (_ctx.preference.type === 'boolean')
      ? (_openBlock(), _createBlock(_unref(ElSwitch), {
          key: 3,
          "active-color": "#5022a6",
          id: "flow-active",
          onChange: updateValue,
          class: "element-switch-oneteg align-items-center width-100",
          width: 48,
          modelValue: val.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((val).value = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.preference.type === 'number')
      ? (_openBlock(), _createBlock(_unref(ElInputNumber), {
          key: 4,
          modelValue: val.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((val).value = $event)),
          min: 1,
          max: 60,
          onChange: updateValue,
          "controls-position": "right",
          "value-on-clear": 15,
          class: "width-100",
          size: "small"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.preference.type === 'number-enum')
      ? (_openBlock(), _createBlock(_unref(ElSelect), {
          key: 5,
          size: "small",
          class: "width-100",
          onChange: updateValue,
          placeholder: _unref(t)(_ctx.preference.label),
          modelValue: val.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((val).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preference.options, (option) => {
              return (_openBlock(), _createBlock(_unref(ElOption), {
                value: option,
                label: option,
                key: option
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["placeholder", "modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.preference.type === 'color-array')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val.value, (color, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"padding":"4px"},
                class: "d-flex align-items-center justify-content-center"
              }, [
                _createVNode(_unref(ElColorPicker), {
                  modelValue: val.value[index],
                  "onUpdate:modelValue": ($event: any) => ((val.value[index]) = $event),
                  onChange: updateValue,
                  predefine: predefinedColors.value
                }, null, 8, ["modelValue", "onUpdate:modelValue", "predefine"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})